import req from '../req'
// 社群授权设置

// 社群配置-获取配置详情接口
export function getMembership (params) {
  return req.get('/setting/customer', params)
}

// 社群配置-保存配置详情接口
export function setMembership (params) {
  return req.post('/setting/customer', params)
}
